import { useMemo } from 'react';
import ShippingDocumentFile from './ShippingDocumentFile';
import { ShippingDocumentsTypes } from 'src/entities/Order';

const ShippingDocument = ({
  shippingDocuments,
  orderNumber,
  uploadDocument,
  canEditTracking,
}) => {
  const shippingDocument = useMemo(() =>
    shippingDocuments.find(
      doc => doc.documentType === ShippingDocumentsTypes.CTE,
    ),
  );

  return (
    <div className="row d-flex items-start mt-5">
      <div className="col-12 col-md-4">
        <h4 className="mb-1 fw-bold"> Comprovante de envio</h4>
        <p className="text-secondary ">deve mostrar o valor do frete</p>
      </div>
      <div className="col-12 col-md-4">
        <ShippingDocumentFile
          shippingDocument={shippingDocument}
          orderNumber={orderNumber}
          uploadDocument={uploadDocument}
          canEditTracking={canEditTracking}
        />
      </div>
      <div className="col-12 col-md-4"></div>
      <div className="col-12 col-md-4"></div>
      <div className="col-12 col-md-8">
        <p className="text-secondary no-wrap">
          <span className="text-bold">Atenção:</span> apenas após preencher os
          dados de envio e anexar o comprovante de envio é que o pedido será
          incluído para repasse.
        </p>
      </div>
    </div>
  );
};

export default ShippingDocument;
